import type { SupportedLocale } from "staticConfiguration";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDateFns } from "@mui/x-date-pickers-pro/AdapterDateFns";
import { LocaleOverrideContext } from "core/hooks/LocaleOverrideContext";
import { de, enCA, es, frCA, type Locale } from "date-fns/locale";
import { useRouter } from "next/router";
import { type ReactNode, useContext } from "react";

const localeMap: Record<SupportedLocale, Locale> = {
  en: enCA,
  fr: frCA,
  es,
  "de-DE": de,
};

export function DatePickerLocalizationProvider({
  children,
}: {
  children: ReactNode;
}) {
  const overrideLocale = useContext(LocaleOverrideContext);
  const { locale: routerLocale } = useRouter();
  const locale = overrideLocale || routerLocale;
  const providerLocale = localeMap[locale as keyof typeof localeMap] || enCA;
  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={providerLocale}
    >
      {children}
    </LocalizationProvider>
  );
}
